import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { customersApi } from '../api/customersApi';
export function useCustomer(id: string) {
  const { isDemo, store, scopeKey } = useWorkspace(); const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'customer', id, isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.customers.find(c => c.id === id && c.store_id === store?.id) || null) : customersApi.get(id, signal), enabled: Boolean(store?.id && id), staleTime: 30_000 });
}
